import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import PrincipalPanel from 'scoreboard/components/principal-panel'
import i18n from 'scoreboard/components/i18n'
import SyncedItemTooltip from 'scoreboard/components/synced-item-tooltip'
import { isV6 } from 'scoreboard/components/version'

/**
 * Adds support for owners that come from the scorecard item's template
 * to the default principal panel
 */
const ScorecardsOwnersPanel = PrincipalPanel.extend({

	initialize: function(options) {
		let columnHeaders
		if (isV6()) {
			columnHeaders = [
				i18n.get('common.name'),
				'', // No header for column
				i18n.get('common.delete')]
		}
		let superOptions = _.extend({ columnHeaders }, options)
		PrincipalPanel.prototype.initialize.call(this, superOptions)
	},

	/**
	 * @override
	 */
	renderPrincipal: function (principal) {
		var html = $(PrincipalPanel.prototype.renderPrincipal.apply(this, arguments))

		if (principal.fromTemplate) {
			html.attr('data-from-template', true)
			this.syncedItemTooltip = new SyncedItemTooltip({
				el: html.find('.table-actions-cell'),
				attachTo: html.find('.delete'),
				itemType: i18n.get('common.owner')
			}).render()
		}

		return html
	},

	/**
	 * @override
	 */
	readPrincipalOptionsFromDomRow: function (row, principal) {
		if (row.data().fromTemplate) {
			principal.fromTemplate = true
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.syncedItemTooltip], 'remove')
	}
})

export default ScorecardsOwnersPanel

ScorecardsOwnersPanel.__filename__ = 'scorecards/edit/scorecards-owners-panel.js'
